import * as tslib_1 from "tslib";
import { Topology } from '@wix/wixstores-client-core/dist/es/src/constants';
import { query as getFiltersQueryString } from '../graphql/getFilters.graphql';
var FiltersApi = /** @class */ (function () {
    function FiltersApi(siteStore) {
        this.siteStore = siteStore;
    }
    FiltersApi.prototype.getFilters = function (filtersConfigTypeDTO, mainCollectionId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = {
                    query: getFiltersQueryString,
                    variables: { enabledFilters: filtersConfigTypeDTO, mainCategory: mainCollectionId },
                    source: 'WixStoresWebClient',
                    operationName: 'getFilters',
                };
                return [2 /*return*/, this.siteStore.httpClient.post(this.siteStore.resolveAbsoluteUrl("/" + Topology.STOREFRONT_GRAPHQL_URL), query)];
            });
        });
    };
    return FiltersApi;
}());
export { FiltersApi };
//# sourceMappingURL=filtersApi.js.map